<template>
  <v-container fluid>

    <!-- PC -->
    <v-row dense class="hidden-sm-and-down mx-8">
      <v-col cols="12" sm="12" md="6" lg="6" style="margin-top: 1%">

        <h3 style="color: rgb(54, 54, 54); font-size: 1.5em;" class="mx-6">A comprehensive knowledgebase of
          <span style='color:rgb(245, 177, 73)'>A</span>lternative
          <span style='color:rgb(114, 187, 232)'>S</span>plicing in human
          <span style='color:rgb(165, 212, 172)'>Cancer</span>s
        </h3>

        <span class="d-flex flex-row justify-space-around mx-4 mt-4">
          <v-btn class="ma-1" to="/tools/regnet" large color="rgb(245, 177, 73)" width="25%">
            <span class="font-weight-bold" style="">Splicing Regulation</span>
          </v-btn>

          <!-- <v-divider class="mt-6"></v-divider> -->
          <div class="d-flex justify-center" id="arrow1" style="width:15%">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" height='45px'>
              <marker id='markerArrow1' markerUnits='strokeWidth' refX='6' refY='6' markerHeight='12' markerWidth='12'
                orient='auto'>
                <path d='M2,2 L10,6 L2,10 L6,6 L2,2' style='fill:rgb(245, 177, 73)' />
              </marker>
              <!-- <line x1='20'
                  y1='25'
                  x2='50'
                  y2='25'
                  stroke='#BDBDBD'
                  stroke-width='2'
                  marker-end='url(#markerArrow1)'>
            </line> -->
            </svg>
          </div>

          <v-btn class="ma-1" to="/browse/knowledge" large color="rgb(114, 187, 232)" width="20%">
            <span class="font-weight-bold">Splicing Event</span>
          </v-btn>

          <!-- <v-divider class="mt-6"></v-divider> -->
          <div class="d-flex justify-center" id="arrow2" style="width:15%">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" height='45px'>
              <marker id='markerArrow2' markerUnits='strokeWidth' refX='6' refY='6' markerHeight='12' markerWidth='12'
                orient='auto'>
                <path d='M2,2 L10,6 L2,10 L6,6 L2,2' style='fill:rgb(114, 187, 232)' />
              </marker>
              <!-- <line x1='20'
                  y1='25'
                  x2='50'
                  y2='25'
                  stroke='#BDBDBD'
                  stroke-width='2'
                  marker-end='url(#markerArrow2)'>
            </line> -->
            </svg>
          </div>

          <v-btn class="ma-1" to="/biofunc" large color="rgb(165, 212, 172)" width="20%">
            <span class="font-weight-bold">Splicing Effect</span>
          </v-btn>
        </span>

        <div class="d-flex flex-row justify-space-around mx-5 mt-5">
          <v-select :items="categories" v-model="selectedCategory" solo style="max-width:25%;">
          </v-select>
          <v-combobox v-model="select" clearable clear-icon="mdi-close-circle" hide-selected solo hide-no-data
            :placeholder="label" :error-messages="error_message" :loading="loading" :items="items"
            :search-input.sync="search" @keyup.enter="goToSearchResults()">
            <template v-slot:append="">
              <v-btn icon @click="goToSearchResults()" style="z-index:1">
                <v-icon>mdi-database-search</v-icon>
              </v-btn>
            </template>
          </v-combobox>
        </div>

        <!-- examples -->
        <div class="d-flex flex-row mx-5 mt-n7">
          <span style="position:relative;left:26%;">e.g.,
            <a class="mx-1" style="font-size: 0.85em" @click="regulator_example"><span class="">SF3B1;</span></a>
            <a class="mx-1" style="font-size: 0.85em" @click="gene_example"><span class="">EZH2;</span></a>
            <a class="mx-1" style="font-size: 0.85em" @click="cancer_example"><span class="">Acute Myeloid
                Leukemia;</span></a>
            <a class="mx-1" style="font-size: 0.85em" @click="biofunc_example"><span class="d">Apoptosis</span></a>
          </span>
        </div>

        <!-- Splicing Knowledge -->
        <div class="mx-5 mt-2">
          <knowledge-statistics></knowledge-statistics>
        </div>

        <!-- Splicing Datasets -->
        <div class="mx-5 mt-3">
          <datasets-statistics></datasets-statistics>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="6" class="d-flex flex-column">
        <!-- <v-card height="650"
                elevation="0"> -->
        <human-body></human-body>
        <!-- <v-divider></v-divider> -->
        <!-- <v-row class="mt-5">
          <v-col cols="8">
            <v-card outlined
                    height="130px">
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="noclick"
                    outlined
                    style="max-width:70%">
              <div id="revolverMaps"></div>
            </v-card>
          </v-col>
        </v-row> -->
      </v-col>
    </v-row>
     <v-row dense class="hidden-sm-and-down mx-14 mt-5">
      <v-col sm="12" md="12" lg="12" cols="12">
        <v-alert color="success" text dense icon="mdi-information-outline">
          Please cite our publication as "<a
            href="https://academic.oup.com/nar/advance-article/doi/10.1093/nar/gkac955/6786203?searchresult=1"
            target="_blank">ASCancer
            Atlas: a comprehensive knowledgebase of alternative
            splicing in human
            cancers.</a> <i>Nucleic Acids Res.</i> 2022. <a href="https://pubmed.ncbi.nlm.nih.gov/36318242/"
            target="_blank">[PMID=36318242]</a>"
        </v-alert>
      </v-col>
    </v-row>
    <v-row dense class="hidden-sm-and-down mx-14 mt-n2">
      <v-col sm="12" md="12" lg="12" cols="12">
        <v-alert color="info" text dense icon="mdi-information-outline" dismissible>
          To get the best user experience, please ensure that your browser is the latest version of Microsoft Edge,
          Google Chrome, Firefox, or Safari.
        </v-alert>
      </v-col>
    </v-row>

    <!-- Phone -->
    <v-row dense class="hidden-md-and-up">
      <v-col cols="12" sm="12" md="6" lg="6" style="margin-top: 1%">

        <h3 style="color: rgb(54, 54, 54); font-size: 1.15em;" class="mx-6">A comprehensive knowledgebase of
          <span style='color:rgb(245, 177, 73)'>A</span>lternative
          <span style='color:rgb(114, 187, 232)'>S</span>plicing in human
          <span style='color:rgb(165, 212, 172)'>Cancer</span>s
        </h3>

        <span class="d-flex flex-column justify-space-around mx-2 mt-4">
          <v-btn class="ma-1" to="/tools/regnet" large color="rgb(245, 177, 73)">
            <span class="font-weight-bold" style="">Splicing Regulation</span>
          </v-btn>

          <v-icon large color="rgb(245, 177, 73)">mdi-arrow-down-bold</v-icon>

          <v-btn class="ma-1" to="/browse/knowledge" large color="rgb(114, 187, 232)">
            <span class="font-weight-bold">Splicing Event</span>
          </v-btn>

          <v-icon large color="rgb(114, 187, 232)">mdi-arrow-down-bold</v-icon>

          <v-btn class="ma-1" to="/biofunc" large color="rgb(165, 212, 172)">
            <span class="font-weight-bold">Splicing Effect</span>
          </v-btn>
        </span>

        <div class="d-flex flex-row justify-space-around mx-3 mt-5">
          <v-select :items="categories" v-model="selectedCategory" solo style="max-width:35%;">
          </v-select>
          <v-combobox v-model="select" clearable clear-icon="mdi-close-circle" hide-selected solo hide-no-data
            :placeholder="label" :error-messages="error_message" :loading="loading" :items="items"
            :search-input.sync="search" @keyup.enter="goToSearchResults()">
            <template v-slot:append="">
              <v-btn icon @click="goToSearchResults()" style="z-index:1">
                <v-icon>mdi-database-search</v-icon>
              </v-btn>
            </template>
          </v-combobox>
        </div>

        <!-- examples -->
        <div class="d-flex flex-row ml-2 mt-n5">
          <span>e.g.,
            <a class="mx-1" style="font-size: 0.85em" @click="regulator_example"><span class="">SF3B1;</span></a>
            <a class="mx-1" style="font-size: 0.85em" @click="gene_example"><span class="">EZH2;</span></a>
            <a class="mx-1" style="font-size: 0.85em" @click="cancer_example"><span class="">Acute Myeloid
                Leukemia;</span></a>
            <a class="mx-1" style="font-size: 0.85em" @click="biofunc_example"><span class="d">Apoptosis</span></a>
          </span>
        </div>

        <!-- Splicing Knowledge -->
        <div class="mx-3 mt-4">
          <knowledge-statistics></knowledge-statistics>
        </div>

        <!-- Splicing Datasets -->
        <div class="mx-3 mt-3">
          <datasets-statistics></datasets-statistics>
        </div>
      </v-col>
    </v-row>
    <v-row dense class="hidden-md-and-up mx-2 mt-5">
      <v-col sm="12" md="12" lg="12" cols="12">
        <v-alert color="success" text dense icon="mdi-information-outline" prominent>
          Please cite our publication as "<a
            href="https://academic.oup.com/nar/advance-article/doi/10.1093/nar/gkac955/6786203?searchresult=1"
            target="_blank">ASCancer
            Atlas: a comprehensive knowledgebase of alternative
            splicing in human
            cancers.</a> <i>Nucleic Acids Res.</i> 2022. <a href="https://pubmed.ncbi.nlm.nih.gov/36318242/"
            target="_blank">[PMID=36318242]</a>"
        </v-alert>
      </v-col>
    </v-row>
    <v-row dense class="hidden-md-and-up mx-2 mt-n2">
      <v-col sm="12" md="12" lg="12" cols="12">
        <v-alert color="info" text dense icon="mdi-information-outline" dismissible prominent>
          To get the best user experience, please ensure that your browser is the latest version of Google Chrome,
          Microsoft Edge, Firefox, Safari or Internet Explorer 10 and above.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import { getAllGeneNamesFromGeneInfo } from 'node/general';
import { getAllRegulatoryNetwork } from 'node/splice_regulatory_network.js';
import { getAllCancerFromSV } from "node/browse";
import { getBasicStatisticFromKnowledge } from 'node/statistic.js';
import HumanBody from '@/components/main/HumanBody.vue';
import KnowledgeStatistics from "@/components/main/KnowledgeStatistics";
import DatasetsStatistics from "@/components/main/DatasetsStatistics";
import * as d3 from 'd3-selection';
// import postscribe from 'postscribe';

export default {
  name: 'Home',
  components: {
    HumanBody,
    KnowledgeStatistics,
    DatasetsStatistics
  },
  data() {
    return {
      categories: ["Splicing Regulator", "Gene Name", "Cancer Type", "Splicing Effect"],
      selectedCategory: "Gene Name",
      label: 'Please input the Gene Name',
      select: null,
      search: null,
      loading: false,
      message: "",
      error_message: null,
      items: [],
      dataList: [],

      bio_func_items: ["Apoptosis", "Autophagy", "Angiogenesis", "Aerobic Glycolysis",
        "Cell Migration", "Cell Invasion", "Cell Differentiation",
        "Cell Growth", "Cell Survival", "Cell Proliferation",
        "DNA Damage", "DNA Repair", "EMT", "Metastasis",
        "Metabolism", "Immune", "Inflammation"],

      // splicing_entry_count: 0,
      // cancer_subtype_count: 0,
      // gene_name_count: 0,
      // as_type_count: 0,
      // tissue_type_count: 0,
      // pubmed_count: 0,
    }
  },
  created() {
    this.getAllGeneNamesFromGeneInfo();
  },
  mounted() {
    // this.getBasicStatisticFromKnowledge();

    this.plotArrow();


    // this.getAllRegulatoryNetwork();
    // this.getAllGeneNamesFromGeneInfo();
    // this.getAllCancerFromSV();

    // postscribe('#revolverMaps',// Note: /script need to transform as \/script
    //   `<script type="text/javascript" src="//rf.revolvermaps.com/0/0/7.js?i=5d1ezjfzq7f&amp;m=0&amp;c=ff0000&amp;cr1=ffffff&amp;sx=0" async="async"><\/script>`)
  },
  watch: {
    selectedCategory(newValue, oldValue) {
      // console.log(newValue);
      if (newValue == "Splicing Regulator") {
        this.select = null;
        this.search = null;
        this.items = [];
        this.label = "Please input the Splicing Regulator / Gene Name";
        this.getAllRegulatoryNetwork();
      } else if (newValue == "Gene Name") {
        this.select = null;
        this.search = null;
        this.items = [];
        this.label = "Please input the Gene Name";
        this.getAllGeneNamesFromGeneInfo();
      } else if (newValue == "Cancer Type") {
        this.select = null;
        this.search = null;
        this.items = [];
        this.label = "Please input the Cancer Type";
        this.getAllCancerFromSV()
      } else if (newValue == "Splicing Effect") {
        this.select = null;
        this.search = null;
        this.items = this.bio_func_items;
        this.label = "Please select the Biological Function";
        // this.getAllBiologicalFunctionFromSV();
      }
    },
    select(val) {
      if (this.selectedCategory == "Splicing Regulator") {
        if (val == null) {
          this.label = "Please input the Splicing Regulator / Gene Name"
        } else if (val && this.dataList.includes(val)) {
          this.select = val;
          this.label = null;
        } else {
          this.select = null;
        };
      } else if (this.selectedCategory == "Gene Name") {
        if (val == null) {
          this.label = "Please input the Gene Name"
        } else if (val && this.dataList.includes(val)) {
          this.select = val;
          this.label = null;
        } else {
          this.select = null;
        };
      } else if (this.selectedCategory == "Cancer Type") {
        // console.log(this.dataList);
        if (val == null) {
          this.label = "Please input the Cancer Type"
        } else if (val && this.dataList.includes(val)) {
          // console.log('true');
          this.select = val;
          this.label = null;
        } else {
          // console.log('false');
          this.select = null;
        };
      }
    },
    search(val) {
      if (this.selectedCategory == "Splicing Regulator") {
        val && val !== this.select && this.regulatorQuerySelections(val);
      } else if (this.selectedCategory == "Gene Name") {
        val && val !== this.select && this.geneQuerySelections(val);
      } else if (this.selectedCategory == "Cancer Type") {
        val && val !== this.select && this.cancerQuerySelections(val);
      }
    },
  },
  methods: {
    async getAllGeneNamesFromGeneInfo() {
      await getAllGeneNamesFromGeneInfo().then(data => {
        // console.log(data);
        if (data) {
          this.dataList = data;
        }
      }).catch(err => console.error(err))
    },
    // get all cancer types
    async getAllCancerFromSV() {
      await getAllCancerFromSV().then(data => {
        if (data) {
          // console.log(data);
          let cancerNames = [...new Set(data)].filter(a => a.length > 0);
          // let cancerNames = [];
          // data.forEach((v, i, a) => {
          //   if (v.indexOf(',')) {
          //     let arr = v.split(', ');
          //     cancerNames.push(...arr);
          //   } else {
          //     cancerNames.push(v);
          //   }
          // })
          // console.log(cancerNames);
          this.dataList = cancerNames; // uniq array
        }
      }).catch(err => console.error(err))
    },
    async getAllRegulatoryNetwork() {
      await getAllRegulatoryNetwork().then(data => {
        if (data) {
          let node_ids = [];
          data[0].nodes.forEach(v => {
            node_ids.push(v.id)
          });
          // console.log(node_ids);
          this.dataList = node_ids; // all nodes genes
        }
      }).catch(err => console.error(err))
    },
    geneQuerySelections(v) {
      this.label = null;
      this.error_message = null;
      this.loading = true;
      setTimeout(() => {
        this.items = this.dataList.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        })
        this.loading = false
        // show the no data tips when the search result is null
        if (this.items.length == 0) {
          // window.alert("Sorry, we cant' find the Gene Name you entered.")
          // this.error_message = "Sorry, we cant' find the Gene Name you entered.";
          this.error_message = '   ';
        }
      }, 500)
    },
    cancerQuerySelections(v) {
      this.label = null;
      this.loading = true;
      this.error_message = null;
      setTimeout(() => {
        this.items = this.dataList.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        });
        this.loading = false
        // show the no data tips when the search result is null
        if (this.items.length == 0) {
          // window.alert("Sorry, we cant' find the Cancer Type you entered.")
          // this.error_message = "Sorry, we cant' find the Cancer Type you entered.";
          this.error_message = '   ';
        }
      }, 500)
    },
    regulatorQuerySelections(v) {
      this.label = null;
      this.loading = true;
      this.error_message = null;
      setTimeout(() => {
        this.items = this.dataList.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        });
        this.loading = false
        // show the no data tips when the search result is null
        if (this.items.length == 0) {
          // window.alert("Sorry, we cant' find this Splicing Regulator or Target Gene you entered.")
          // this.error_message = "Sorry, we cant' find this Splicing Regulator you entered.";
          this.error_message = '   ';
        }
      }, 500)
    },
    goToSearchResults() {
      if (this.selectedCategory == "Splicing Regulator") {
        this.goToRegulationNetwork();
      } else if (this.selectedCategory == "Gene Name") {
        this.goToGeneSearchResult();
      } else if (this.selectedCategory == "Cancer Type") {
        this.goToKnowledgeCancer();
      } else if (this.selectedCategory == "Splicing Effect") {
        this.goToSplicingEffect();
      }
    },
    goToGeneSearchResult() {
      let genename = this.select;
      if (genename) {
        this.$router.push({
          path: '/search',
          query: {
            genename: genename,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (genename == null || genename == '') {
        window.alert("Sorry, please input the correct Gene Name !")
      }
    },
    goToKnowledgeCancer() {
      let cancername = this.select;
      if (cancername) {
        this.$router.push({
          path: '/browse/knowledge',
          query: {
            cancername: cancername,
            page: 1,
            size: 15
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (cancername == null || cancername == '') {
        window.alert("Sorry, we cant' find the Cancer Type you entered !")
      }
    },
    goToRegulationNetwork() {
      let regulator = this.select;
      if (regulator) {
        this.$router.push({
          path: '/tools/regnet',
          query: {
            regulator: regulator,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (regulator == null || regulator == '') {
        window.alert("Sorry, we cant' find the Splicing Regulator or Target Gene you entered.")
      }
    },
    goToSplicingEffect() {
      let functional = this.select;
      if (this.bio_func_items.includes(functional)) {
        this.$router.push({
          path: '/biofunc',
          query: {
            functional: functional,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else {
        window.alert("Sorry, we cant' find the Splicing Effect you entered !")
      }
    },
    async getBasicStatisticFromKnowledge() {
      await getBasicStatisticFromKnowledge().then(data => {
        if (data) {
          // console.log(data);
          data.forEach(d => {
            if (d[0] && d[0]['_id'] == "splicing_entry_count") {
              this.splicing_entry_count = d[0]['count'];
            }
            if (d[0] && d[0]['_id'] == "cancer_subtype_count") {
              this.cancer_subtype_count = d[0]['count'];
            }
            if (d[0] && d[0]['_id'] == "gene_name_count") {
              this.gene_name_count = d[0]['count'];
            }
            if (d[0] && d[0]['_id'] == "as_type_count") {
              this.as_type_count = d[0]['count'];
            }
            if (d[0] && d[0]['_id'] == "tissue_type_count") {
              this.tissue_type_count = d[0]['count'];
            }
            if (d[0] && d[0]['_id'] == "pubmed_count") {
              this.pubmed_count = d[0]['count'];
            }

          });
          // console.log(this.gene_name_count);
        }
      }).catch(err => { console.error(err); })
    },
    plotArrow() {
      let svg1 = d3.selectAll("div#arrow1 > svg");
      // console.log(svg1);
      let svg2 = d3.selectAll("div#arrow2 > svg");
      // console.log(svg2);

      let width = document.getElementById("arrow1").clientWidth;
      let height = document.getElementById("arrow1").clientHeight;
      // console.log(width / 2);
      // console.log(height);
      let arrowLoc1 = width / 4;
      let arrowLoc2 = width / 4 * 3;
      let arrowLoc3 = height / 2;

      svg1.append('g').append('line').attr('x1', arrowLoc1).attr('y1', arrowLoc3)
        .attr('x2', arrowLoc2).attr('y2', arrowLoc3).attr('stroke', 'rgb(245, 177, 73)')
        .attr('stroke-width', '2').attr('marker-end', 'url(#markerArrow1)')
      svg2.append('g').append('line').attr('x1', arrowLoc1).attr('y1', arrowLoc3)
        .attr('x2', arrowLoc2).attr('y2', arrowLoc3).attr('stroke', 'rgb(114, 187, 232)')
        .attr('stroke-width', '2').attr('marker-end', 'url(#markerArrow2)')
    },
    regulator_example() {
      this.selectedCategory = "Splicing Regulator";
      setTimeout(() => {
        this.select = "SF3B1";
      }, 200);
    },
    gene_example() {
      this.selectedCategory = "Gene Name";
      setTimeout(() => {
        this.select = "EZH2";
      }, 300);
    },
    cancer_example() {
      this.selectedCategory = "Cancer Type";
      setTimeout(() => {
        this.select = "Acute Myeloid Leukemia";
      }, 200);
    },
    biofunc_example() {
      this.selectedCategory = "Splicing Effect";
      setTimeout(() => {
        this.select = "Apoptosis";
      }, 50);
    }
  },
}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 1em

.v-card__title
  line-height: 0.5rem

.noclick
  pointer-events: none
  cursor: none
</style>